<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="d-flex smart-item">
        <v-layout text-right wrap>
          <v-flex pt-2 pb-2 pa-2>
            <v-layout wrap>
              <v-flex xl3 lg3 md3 xs12 class="smart-item-title">
                <span class="display-24">{{ text }}</span>
                <span
                  v-if="required && !displayedSelections"
                  class="red--text display-14 d-block"
                >
                  * {{ t(`titles.requiredField`) }}
                </span>
              </v-flex>
              <v-divider
                vertical
                class="ml-1"
                v-show="$vuetify.breakpoint.smAndUp"
              />
              <v-flex
                class="display-18 smart-item-fields py-1"
                align-self-center
              >
                {{ displayedSelections }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-1 pa-0">
      <v-flex xs12>
        <v-layout wrap justify-start mt-2>
          <v-flex
            v-for="(item, i) in items"
            :key="i"
            xl2
            lg2
            md2
            sm3
            xs5
            class="check-item mr-2 pr-2"
            justify-start
          >
            <CheckBox
              :item="item"
              class="black--text"
              @displaySelected="handleDisplaySelected(item)"
              :disabled="disable && item.Code === lastSelection"
            />
          </v-flex>
          <v-flex xs12 text-right mt-2>
            <small
              v-if="selections.length < showMsgIfLessThen"
              class="red--text display-14"
            >
              * {{ cautionMsg }}
            </small>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { join, indexOf, without, pick } from 'lodash';
import CheckBox from '@/components/Wrappers/CheckBox/CheckBox';

export default {
  components: {
    CheckBox,
  },

  props: {
    items: {
      type: Array,
      default: Array,
    },

    text: {
      type: String,
      default: '',
    },

    cautionMsg: {
      type: String,
      default: '',
    },

    showMsgIfLessThen: {
      type: Number,
    },

    required: {
      type: Boolean,
    },
  },

  data() {
    return {
      selections: [],
      selectionsCodes: [],
      disable: false,
 
      lastSelection: undefined,
    };
  },

  computed: {
    displayedSelections() {
      return this.selections.length ? join(this.selections, ' , ') : '';
    },
  },

  watch: {
    selections() {
      this.$emit('selectionsUpdated', this.selectionsCodes);
   

      if (this.selections.length === 1) {
        this.disable = true;
        this.lastSelection = this.selectionsCodes[0];
      } else {
        this.disable = true;
        this.lastSelection = undefined;
      }
    },

  },

  mounted() {
    this.markUsersSelections();
  },

  methods: {
    markUsersSelections() {
      this.items.forEach((i) => {
        const selected = pick(i, 'NameInHebrew', 'Code', 'IsSelected');
        if (selected.IsSelected) {
          this.handleDisplaySelected(selected);
        }
      });
    },

    handleDisplaySelected(selection) {
      if (indexOf(this.selections, selection.NameInHebrew) === -1) {
        this.selections.push(selection.NameInHebrew);
        this.selectionsCodes.push(selection.Code);
      } else {
        this.selections = without(this.selections, selection.NameInHebrew);
        this.selectionsCodes = without(this.selectionsCodes, selection.Code);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#smart-manager .v-expansion-panel-content__wrap * {
  padding-bottom: 0;
}
.caution {
  color: red;
  align-self: flex-start;
}

.check-item {
  margin: 5px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

@media only screen and (min-width: 960px) {
  .check-item {
    background: #f2f2f2;
    margin: 5px;
    height: 100px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    margin-left: 30px;
  }
}
</style>
